//Reducer Types
export interface MatchState {
	list: any;
	count: number;
}
export interface Match {
	match: MatchState;
}
interface MatchListSuccess {
	type: "MATCH_LIST_SUCCESS";
	payload: {
		list: any;
		count: number;
	};
}

type Action = MatchListSuccess;

export const matchReducer = (
	state: MatchState = {
		list: undefined,
		count: 0,
	},
	action: Action
): MatchState => {
	switch (action.type) {
		case "MATCH_LIST_SUCCESS":
			return {
				...state,
				list: action.payload.list,
				count: action.payload.count,
			};

		default:
			return state;
	}
};
